import omit from "lodash/omit";
import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const employeeIDCardListService = (
  params: Types.EmployeeIDCardListRequest
) =>
  RestAPIClient.call<Types.EmployeeIDCardListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List.replace("{employeeId}", params.employeeId.toString()),
    config: {
      requireAuthentication: true,
      params: omit(params, ["employeeId"]),
    },
  });

export const employeeIDCardCreateService = (
  params: Types.EmployeeIDCardCreateRequest
) =>
  RestAPIClient.call<Types.EmployeeIDCard>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create.replace("{employeeId}", params.employeeId.toString()),
    config: {
      requireAuthentication: true,
    },
    data: omit(params, ["employeeId"]),
  });

export const employeeIDCardUpdateService = (
  params: Types.EmployeeIDCardUpdateRequest
) =>
  RestAPIClient.call<Types.EmployeeIDCard>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update.replace(
      "{employeeId}",
      params.employeeId.toString()
    )}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: omit(params, ["employeeId", "id"]),
  });

export const employeeIDCardDetailService = ({
  employeeId,
  id,
}: {
  employeeId: number;
  id: number;
}) =>
  RestAPIClient.call<Types.EmployeeIDCard>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Update.replace("{employeeId}", employeeId.toString())}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const employeeIDCardDeleteService = ({
  employeeId,
  id,
}: {
  employeeId: number;
  id: number;
}) =>
  RestAPIClient.call<Types.EmployeeIDCard>({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths.Update.replace("{employeeId}", employeeId.toString())}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });
